import { notificationStore } from "./store";
import { StorefrontModule } from "@lib/appRegister";

export const NotificationModule: StorefrontModule = function ({ store }) {
  store.registerModule("notification", notificationStore);
};
